<template>
  <PopupTemplate v-if="show" class="notification-popup" @close="close">
    <div class="notification-popup__container">
      <div class="text-center text-lg text-sonicSilver mb-2">
        {{ title }}
      </div>
      <div class="notification-popup__message">
        {{ message }}
      </div>
    </div>
  </PopupTemplate>
</template>

<script>
  import PopupTemplate from './PopupTemplate';

  export default {
    name: 'NotificationPopup',

    components: {
      PopupTemplate,
    },

    props: {
      show: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: '',
      },
      message: {
        type: String,
        default: '',
      },
    },

    methods: {
      close() {
        this.$store.commit('Notification/closeAlert');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .notification-popup {
    &__container {
      width: rem(400px);
    }
  }
</style>
